module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e0e5baf4d9616b66aaa2e560cf4cfb51.jpg";